const ERROR_MESSAGES = {
    ELEMENT_NOT_FOUND: 'GlowPoints: No glow points found',
    INIT_FAILED: 'GlowPoints: Initialization failed'
};

const CONFIG = {
    ANIMATION: {
        TOOLTIP_DURATION: 5000,
        CYCLE_INTERVAL: 5000
    },
    CLASSES: {
        GLOW_POINT: 'glow-point',
        ACTIVE: 'glow-point--active',
        TOOLTIP: 'glow-point__tooltip',
        TOOLTIP_ARROW: 'glow-point__tooltip-arrow',
        SHOW: 'show',
        HIDE: 'hide'
    },
    STYLES: {
        TOOLTIP: {
            position: 'absolute',
            left: '200%',
            top: '50%',
            transform: 'translateY(-50%)'
        }
    }
};

/**
 * Create and show a tooltip for a glow point
 * @param {HTMLElement} glowPoint - The glow point element to show the tooltip for
 * @returns {void}
 */
const showTooltip = (glowPoint) => {
    try {
        // Create tooltip element
        const tooltip = document.createElement('div');
        tooltip.className = CONFIG.CLASSES.TOOLTIP;
        tooltip.innerText = glowPoint.getAttribute('data-code');

        // Create and append arrow
        const arrow = document.createElement('div');
        arrow.className = CONFIG.CLASSES.TOOLTIP_ARROW;
        tooltip.appendChild(arrow);

        // Apply styles
        Object.assign(tooltip.style, CONFIG.STYLES.TOOLTIP);
        glowPoint.appendChild(tooltip);

        // Animate in
        requestAnimationFrame(() => {
            tooltip.classList.add(CONFIG.CLASSES.SHOW);
        });

        // Animate out after duration
        setTimeout(() => {
            tooltip.classList.remove(CONFIG.CLASSES.SHOW);
            tooltip.classList.add(CONFIG.CLASSES.HIDE);
            tooltip.addEventListener('transitionend', () => {
                tooltip.remove();
            });
        }, CONFIG.ANIMATION.TOOLTIP_DURATION);
    } catch (error) {
        console.error(ERROR_MESSAGES.INIT_FAILED, error);
    }
};

/**
 * Initialize glow points functionality
 * @returns {void}
 */
const initializeGlowPoints = () => {
    try {
        const glowPoints = document.querySelectorAll(`.${CONFIG.CLASSES.GLOW_POINT}`);
        
        if (!glowPoints.length) {
            console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
            return;
        }

        let currentIndex = 0;

        /**
         * Cycle through glow points
         * @returns {void}
         */
        const cycleGlowPoints = () => {
            // Remove active class from all points
            glowPoints.forEach((point) => {
                point.classList.remove(CONFIG.CLASSES.ACTIVE);
            });

            // Activate current point and show tooltip
            const currentGlowPoint = glowPoints[currentIndex];
            currentGlowPoint.classList.add(CONFIG.CLASSES.ACTIVE);
            showTooltip(currentGlowPoint);

            // Update index for next cycle
            currentIndex = (currentIndex + 1) % glowPoints.length;
        };

        // Show initial tooltip
        showTooltip(glowPoints[0]);

        // Start cycling
        setInterval(cycleGlowPoints, CONFIG.ANIMATION.CYCLE_INTERVAL);
    } catch (error) {
        console.error(ERROR_MESSAGES.INIT_FAILED, error);
    }
};

export { initializeGlowPoints };
